export {
  SkeletonAvatar,
  SkeletonBadge,
  SkeletonButton,
  SkeletonCard,
  SkeletonChart,
  SkeletonFilterBar,
  SkeletonFormField,
  SkeletonPageHeader,
  SkeletonStatCard,
  SkeletonTable,
  SkeletonTableRow,
  SkeletonText,
} from "./skeleton-blocks";

export { AdminShellSkeleton } from "./AdminShellSkeleton";
export { PublicShellSkeleton } from "./PublicShellSkeleton";

export {
  DashboardPageSkeleton,
  DetailPageSkeleton,
  FormPageSkeleton,
  PublicPageSkeleton,
  ReportsPageSkeleton,
  TableListPageSkeleton,
} from "./page-skeletons";

import {
  DashboardPageSkeleton,
  DetailPageSkeleton,
  FormPageSkeleton,
  PublicPageSkeleton,
  ReportsPageSkeleton,
  TableListPageSkeleton,
} from "./page-skeletons";
import { AdminShellSkeleton } from "./AdminShellSkeleton";
import { PublicShellSkeleton } from "./PublicShellSkeleton";

/**
 * Pick the most appropriate page skeleton for an admin pathname.
 * Used by Suspense fallbacks to match the incoming page shape.
 */
export function pickAdminPageSkeleton(pathname: string): React.ReactNode {
  const path = pathname.replace(/\/+$/, "");

  if (path === "/admin" || path === "/admin/dashboard") {
    return <DashboardPageSkeleton />;
  }

  if (path.startsWith("/admin/reports")) {
    return <ReportsPageSkeleton />;
  }

  if (/^\/admin\/applications\/[^/]+$/.test(path)) {
    return <DetailPageSkeleton />;
  }

  if (path.startsWith("/admin/applications")) {
    return <TableListPageSkeleton />;
  }

  if (
    path.startsWith("/admin/service/new") ||
    path.startsWith("/admin/service/edit") ||
    path.startsWith("/admin/service/categories/create") ||
    path.startsWith("/admin/service/categories/edit")
  ) {
    return <FormPageSkeleton />;
  }

  if (path.startsWith("/admin/service")) {
    return <TableListPageSkeleton />;
  }

  if (
    path.startsWith("/admin/users") ||
    path.startsWith("/admin/roles") ||
    path.startsWith("/admin/faqs") ||
    path.startsWith("/admin/announcements")
  ) {
    return <TableListPageSkeleton />;
  }

  if (path.startsWith("/admin/profile")) {
    return <FormPageSkeleton />;
  }

  return <TableListPageSkeleton />;
}

/**
 * Return the appropriate full-shell skeleton for any pathname.
 * Used as the top-level Suspense fallback in App.tsx.
 */
export function pickRouteLoadingSkeleton(pathname: string): React.ReactNode {
  if (pathname.startsWith("/admin")) {
    return (
      <AdminShellSkeleton>
        {pickAdminPageSkeleton(pathname)}
      </AdminShellSkeleton>
    );
  }
  return (
    <PublicShellSkeleton>
      <PublicPageSkeleton />
    </PublicShellSkeleton>
  );
}
